"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEtherscanApiUrl = void 0;
const config_1 = require("../config");
function getEtherscanApiUrl(network, chain) {
    var _a, _b, _c;
    const url = (_c = (_b = (_a = config_1.config[network]) === null || _a === void 0 ? void 0 : _a.chains) === null || _b === void 0 ? void 0 : _b[chain]) === null || _c === void 0 ? void 0 : _c.etherscanApiUrl;
    if (!url) {
        throw new Error(`etherscan API url not found for chain ${chain}`);
    }
    return url;
}
exports.getEtherscanApiUrl = getEtherscanApiUrl;
